import React from 'react'

import { Modal } from 'antd'
import EstimateForm from '../../../components/estimate/EstimateForm'

const JobSiteEstimatesMOdal = ({
  handleCancel,
  handleFireWrapUpEstimate,
  contentData,
  templates,
  items,
  loadTemplateData,
  loadEstimateData,
  templateSections,
  templateItems,
  estimateSections,
  estimateItems,
  currentId,
  confirmDelete,
  wrapUpEstimate,
  handleWrapUpEstimate,
  changeContentData,
  revisions,
  loadingRevision,
  cloningMode
}) => (
  <Modal
    visible
    title="Estimate"
    width="98%"
    onCancel={handleCancel}
    okText={'Create/Update'}
    onOk={() => handleFireWrapUpEstimate(true)}
    maskClosable={false}
  >
    <EstimateForm
      apiPath={'job/job_site_estimates'}
      estimateInfo={contentData}
      templates={templates}
      items={items}
      loadTemplateData={loadTemplateData}
      loadEstimateData={loadEstimateData}
      templateSections={templateSections}
      templateItems={templateItems}
      estimateSections={estimateSections}
      estimateItems={estimateItems}
      currentId={currentId}
      handleCancel={handleCancel}
      handleDelete={confirmDelete}
      wrapUpEstimate={wrapUpEstimate}
      handleWrapUpEstimate={handleWrapUpEstimate}
      changeContentData={changeContentData}
      revisions={revisions}
      loadingRevision={loadingRevision}
      cloningMode={cloningMode}
      handleFireWrapUpEstimate={handleFireWrapUpEstimate}
    />
  </Modal>
)

export default JobSiteEstimatesMOdal



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobSiteEstimatesModal.js